import React from 'react'
import styled from 'styled-components'


export default styled.div`
  text-align: center;
  margin-bottom: 30px;
`;
